import {popupCreateUpdateService} from "../common/PopupForms";

export default function tableSettingsServices(HelperTable) {

    const selectorTable = '#table-services';
    const elTable = $(selectorTable)

    if (!elTable?.length) {
        return;
    }

    const tableData = HelperTable.getServicesTableData();

    const columns = [
        {
            label: ESR.lang.id,
            data: 'ID',
            orderable: true
        },
        {
            label: ESR.lang.service_title,
            data: 'title',
        },
        {
            label: ESR.lang.price_a,
            data: 'price_a'
        },
        // {
        //     label: ESR.lang.price_c,
        //     data: 'price_c'
        // },
        {
            label: ESR.lang.unit,
            data: 'unit',
        },
        {
            label: 'Ore',
            data: 'hours'
        },
        {
            label: 'Cod',
            data: 'cod'
        },
        {
            label: ESR.lang.visibility,
            data: 'status',
            visible: true,
            render: (data, type, row) => {
                if (type === 'display') {
                    return row.status === 'publish' ? ESR.lang.visible : ESR.lang.hidden
                } else if (type === 'filter') {
                    return row.status
                }
                return data;
            }
        },
        {
            label: ESR.lang.category,
            data: 'term_name',
            className: 'term_name ',
            visible: false
        }
    ];

    const myTableHeader = HelperTable.createRowHeader(columns);
    elTable.append(myTableHeader)

    const toolbar = HelperTable.createToolbarButtons({
        btnAdd: true,
        btnEdit: true,
        btnDelete: false,
    })

    let btnAdd = toolbar.find('.btn-row-add')
    let btnRowEdit = toolbar.find('.btn-row-edit')
    let btnRowRemove = toolbar.find('.btn-row-remove')

    const table = new DataTable(selectorTable, {
        responsive: true,
        select: false,
        data: tableData,
        columns: columns,
        // stateSave: true,
        order: [
            [0, 'dsc']
        ],
        pageLength: 50,
        processing: false,
        serverSide: false,
        info: false,
        layout: {
            topStart: toolbar,
            topEnd: {
                search: {
                    text: '',
                    placeholder: ESR.lang.search
                }
            },
            bottom: 'paging',
            bottomStart: null,
            bottomEnd: null
        },
        language: {
            emptyTable: ESR.lang.emptyTable,
        },
        rowCallback: function(row, data) {
            if( data.status !== 'publish' ){
                $(row).addClass('opacity-70');
            }
        },
        initComplete: function () {
            const api = this.api();
            const state = api.state.loaded()

            const colCategoryIndex = 7;
            const colCategory = api.column(colCategoryIndex)
            let colCategoryStateValue = state?.columns?.[colCategoryIndex]?.search?.search;
            const optionsCategory = HelperTable.createColumnSelectOptions(colCategory);

            const elSelectCategory = ESR.View.select({
                value: colCategoryStateValue,
                placeholder: ESR.lang.all_categories,
                class: 'select-sm',
                options: optionsCategory
            }).on('change', function () {
                colCategory.search($(this).val(), {exact: false}).draw();
            });

            if(colCategoryStateValue){
                colCategory.search(colCategoryStateValue, {exact: false}).draw();
            }

            const colStatusIndex = 5;
            const colStatus = api.column(colStatusIndex);
            const colStatusStateValue = state?.columns[colStatusIndex].search.search ?? '';
            const elSelectStatus = ESR.View.select({
                value: colStatusStateValue,
                class: 'select-vizibility select-sm',
                placeholder: ESR.lang.visibility,
                options: [
                    {value: 'publish', label: ESR.lang.visible},
                    {value: 'private', label: ESR.lang.hidden}
                ]
            }).on('change', function () {
                colStatus.search($(this).val(), {exact: true}).draw();
            });

            if(colStatusStateValue) {
                colStatus.search(colStatusStateValue, {exact: true}).draw();
            }

            $('.dt-layout-end').prepend(elSelectStatus)
            $('.dt-layout-end').prepend(elSelectCategory)
        }
    });


    if (btnAdd.length) {
        // Handle add new project button click
        btnAdd.click((e) => {
            e.preventDefault();
            popupCreateUpdateService({}, ESR.lang.add);
        });

        $('body').on('click', (e) => {
            HelperTable.onSelectRow(e, table, btnRowEdit, btnRowRemove)
        });
    }

    // Handle row edit button click
    if (btnRowEdit.length) {
        btnRowEdit.click((e) => {
            e.preventDefault();
            const elRow = table.row('.selected');
            if (!elRow.node()) {
                return;
            }
            popupCreateUpdateService(elRow.data(), ESR.lang.save);
        });
    }

}